import React, { useContext } from 'react';
import { IterationContext } from '../../contexts/IterationContext';
import Dropdown from 'Components/DesignSystem/Dropdown/Dropdown';

type CategorySelectorProps = {
    id: string;
    categoryId?: string;
};

/**
 * The iteration builder's category picker on the DS `Dropdown` (searchable,
 * portalled) — was the hand-rolled GMS `Select`. `handleCategoryChange` still
 * receives the raw category-id string.
 */
const CategorySelector: React.FC<CategorySelectorProps> = ({ id, categoryId }) => {
    const {
        allCategories,
        iterationPayload,
        handleCategoryChange
    } = useContext(IterationContext);

    const handleChange = (selectedCategoryId: string) => {
        handleCategoryChange(selectedCategoryId);
    };

    return (
        /* No tw-ms-7: the field left-aligns with the iteration card below it. */
        <div className="tw-mt-4 tw-w-[25%]">
            <Dropdown
                id={`${id}-category-select`}
                label="Select Category"
                onChange={(value) => handleChange(String(value))}
                value={iterationPayload?.category_id || categoryId || ""}
                options={(allCategories || []).map(category => ({
                    value: category.id,
                    label: category.name
                }))}
                placeholder="Select"
                searchable
                usePortal
                data-testid={`${id}-category-select`}
            />
        </div>
    );
};

export default CategorySelector;
